//
// locales/glitch/ja.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/ja';
import localeData from 'react-intl/locale-data/ja.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
